import Vue from 'vue';

export default Vue.component('advanced-search', {
    inject: [
        'performSearch',
        'applyAdvancedSearch',
        'resetAdvancedSearch'
    ],
    props:{
        advancedSearch: Object,
        queryParameters: Object,
        resources: Object
    }
});